var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.569 15.2V3.8a3 3 0 0 0-3-3h-7.4L3.968 8v12.2a3 3 0 0 0 3 3h1",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.969 8h5.2a2 2 0 0 0 2-2V.8",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17.6c.746 0 1.326.153 1.74.46.414.307.621.763.621 1.366 0 .63-.203 1.106-.609 1.426-.406.32-.95.48-1.63.48h-.613V23.2h-1.34v-5.6h1.83zm.007 2.78c.316 0 .558-.075.724-.223.166-.148.249-.392.249-.731 0-.587-.332-.88-.997-.88h-.474v1.833h.498zm4.643-2.78c.888 0 1.6.198 2.137.593.537.396.805 1.122.805 2.178 0 1.04-.261 1.771-.785 2.194-.523.423-1.201.635-2.035.635h-1.7v-5.6h1.578zm-.237.961v3.677h.441c.441 0 .777-.136 1.005-.408.23-.272.344-.758.344-1.459 0-.48-.058-.85-.172-1.115-.114-.264-.27-.446-.466-.545-.196-.1-.439-.15-.727-.15h-.425zm3.98 4.639v-5.6h3.375l-.139.945h-1.896v1.487h1.651v.945h-1.65V23.2h-1.341z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDownload);
export default __webpack_public_path__ + "static/media/btn_download.336b087c53a8b0f282bafeac15e7a39b.svg";
export { ForwardRef as ReactComponent };